export default __webpack_public_path__ + "static/media/INEX_Black.e464a48c.png";